"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var services_1 = require("../services");
var actions_1 = require("../entities/actions");
var types_1 = require("../types");
var extendHOC_1 = __importDefault(require("./extendHOC"));
var utils_1 = require("../utils");
function withMatchRefetch(WrappedComponent) {
    var MatchRefetch = /** @class */ (function (_super) {
        __extends(MatchRefetch, _super);
        function MatchRefetch() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getMatchId = function (props) {
                if (props.matchData && props.matchData.id)
                    return props.matchData.id;
                if (props.match && props.match.id)
                    return props.match.id;
                services_1.sentryHub.withScope(function (scope) {
                    scope.setExtras(props);
                    scope.setTag('origin', "withSubscription({" + utils_1.getDisplayName(WrappedComponent) + "):getMatchId");
                    services_1.sentryHub.captureMessage('Can\'t find "matchId');
                });
            };
            return _this;
        }
        MatchRefetch.prototype.componentDidMount = function () {
            this.init();
        };
        MatchRefetch.prototype.componentDidUpdate = function () {
            this.init();
        };
        MatchRefetch.prototype.init = function () {
            var matchId = this.shouldRefetchMatch(this.props);
            if (matchId) {
                return this.refetch(matchId);
            }
        };
        MatchRefetch.prototype.shouldRefetchMatch = function (props) {
            var matchId = this.getMatchId(props);
            if (props.market && matchId && !props.market.name) {
                return matchId;
            }
        };
        MatchRefetch.prototype.refetch = function (matchId) {
            this.store.dispatch(actions_1.refetchMatch({
                sportEventsIds: [matchId],
                marketStatuses: [
                    types_1.GQL.MarketStatus.ACTIVE,
                    types_1.GQL.MarketStatus.DEACTIVATED,
                    types_1.GQL.MarketStatus.SUSPENDED,
                    types_1.GQL.MarketStatus.RESULTED,
                ],
            }));
        };
        MatchRefetch.prototype.render = function () {
            return react_1.default.createElement(WrappedComponent, __assign({}, this.props));
        };
        return MatchRefetch;
    }(react_1.default.Component));
    return extendHOC_1.default(WrappedComponent, MatchRefetch, {
        withStore: true,
    });
}
exports.default = withMatchRefetch;
//# sourceMappingURL=withMatchRefetch.js.map